import React from 'react';
import {hooks} from '../hooks';
import {utils} from '../utils';
import {svg} from '../assets/svg';
import {theme} from '../constants';
import {useNavigate, useLocation} from 'react-router-dom';

// NOTE: You must ensure 'svg.BooksSvg' is available in your svg file.
const tabs = [
    {
        id: 1,
        name: 'Home',
        path: '/',
        icon: svg.HomeTabSvg,
    },
    {
        id: 2,
        name: 'Blog',
        path: '/Blog',
        icon: svg.ExploreTabSvg,
    },
    {
        id: 3,
        name: 'Library',
        path: '/library',
        // Changed icon for Library to something that suggests books/learning
        icon: svg.LibrarySvg,
    },
    {
        id: 5,
        name: 'Profile',
        path: '/profile',
        icon: svg.ProfileTabSvg,
    },
];

export const BottomTabBar: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <nav
            style={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                width: '100%',
                maxWidth: '100%',
                height: '51px', // Increased height to fit icon and text
                backgroundColor: '#eee',
                display: 'flex',
                justifyContent: 'space-around',
                alignItems: 'center',
                padding: '0 10px',
                boxSizing: 'border-box',
                zIndex: 1000,
                boxShadow: '0 -4px 6px -1px rgba(0, 0, 0, 0.1), 0 -2px 4px -2px rgba(0, 0, 0, 0.06)',
            }}
        >
            {tabs.map(tab => {
                const isProtectedTab = tab.name === 'Library' || tab.name === 'Profile';

                const handleTabClick = () => {
                    if (isProtectedTab) {
                        const user = localStorage.getItem('shopifyUser');
                        if (!user) {
                            const confirmation = window.confirm(
                                `You must be signed in to view your ${tab.name.toLowerCase()}. Do you want to sign in now?`
                            );
                            if (confirmation) navigate('/SignIn');
                            return;
                        }
                    }
                    navigate(tab.path);
                };

                const isActive = location.pathname === tab.path;

                return (
                    <div
                        key={tab.id}
                        onClick={handleTabClick}
                        style={{
                            cursor: 'pointer',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flex: 1,
                            minHeight: '60px', // Adjusted for text
                            paddingTop: '5px',
                            gap: '6px', // Space between icon and text
                        }}
                    >
                        {/* ICON: Changed size/thickness via style props.
                           Assuming your SVG component accepts these props. */}
                        <tab.icon 
                            color={isActive ? '#0e0d0dff': '#313030ff'} 
                            style={{ 
                                width: '28px', // Slightly bigger icon
                                height: '28px', 
                                strokeWidth: 2.5, // Thicker line/stroke
                            }}
                        />

                        {/* TEXT: Added tab name under the icon */}
                        <span 
                            style={{
                                color: isActive ?  '#0e0d0dff': '#313030ff',
                                fontSize: '12px',
                                fontWeight: isActive ? 'bold' : 'normal',
                            }}
                        >
                            {tab.name}
                        </span>
                    </div>
                );
            })}
        </nav>
    );
};